import React, { useState } from "react";
import { Grid, Box, Tab, Tabs, Card } from "@mui/material";
import FormSinger from "./FormSinger";
import TableSingers from "./TableSingers";


const Singers = () => {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Grid container spacing={0}>
            <Grid item xs={12} lg={12}>
                <Card variant="outlined">
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', direction: 'ltr' }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="lab API tabs example"
                            textColor="secondary"
                            indicatorColor="secondary"
                        >
                            <Tab label="ثبت مداح جدید" value="1" />
                            <Tab label="لیست مداحان" value="2" />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index="1">
                        <FormSinger />
                    </TabPanel>
                    <TabPanel value={value} index="2">
                        <TableSingers />
                    </TabPanel>
                </Card>
            </Grid>
        </Grid>
    );
};

const TabPanel = ({ children, value, index }) => {
    return (
        <div
            style={{ direction: 'rtl' }}
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
};

export default Singers;
